var Format = {
  cardNumber: function (cardNumber, cardBrand) {
    let formatted = '';
    if (cardNumber && (cardNumber.toString().trim())) {
      cardNumber = cardNumber.toString().replace(/[^0-9]/g, '');

      let maxLength = Math.max.apply(null, cardBrand.lengths);
      cardNumber = cardNumber.substring(0, maxLength);

      let start = 0;
      for (let i = 0, spaces = cardBrand.spaces.length; i < spaces; i++) {
        let end = cardBrand.spaces[i];
        formatted = formatted + ' ' + cardNumber.substring(start, end);
        start = end;
      }
      formatted = formatted + ' ' + cardNumber.substring(start, cardNumber.length);
    }
  
    return formatted.trim();
  },

  cursorPosition: function(oldPosition, oldValue, formattedValue) {
    oldPosition = (oldPosition && oldPosition.toString().trim()) ? oldPosition : 0;
    if (isNaN(oldPosition) || (oldPosition === 0) || !formattedValue || formattedValue.length === 0) {
      return 0;
    } else {
      let newPosition = 0;
      oldValue = oldValue ? oldValue : '';

      // get numeric characters before cursor
      let numValuesBeforeCursor = oldValue.substring(0, oldPosition).replace(/\D/g, '');
      let lengthOfFormatted = formattedValue.length;

      // for each value in old value
      for (let i = 0, charsCount = numValuesBeforeCursor.length; i < charsCount; i++) {
        while (newPosition < lengthOfFormatted && (numValuesBeforeCursor[i] !== formattedValue[newPosition])) {
          newPosition++;
        }
        newPosition++;
      }

      // handle non-numbers at end
      if (isNaN(parseInt(formattedValue.slice(-1)))) {
        newPosition = lengthOfFormatted;
      }

      // restrict length
      if (lengthOfFormatted < newPosition) {
        newPosition = lengthOfFormatted;
      }

      return newPosition;
    }
  },

  expiry: function(expiry) {
    if (expiry === null) {
      return '';
    }
    
    const EXPIRY_SEPARATOR = '/';

    let formatted = expiry;

    // if month is set and year is not, do not append if moving back to month
    let appendSeparator = !(/^(\d{1,2}) \/$/.test(expiry));

    if (expiry && (expiry.toString().trim())) {
      expiry = expiry.toString().replace(/[^0-9\/]/g, '');

      let expiryParts = expiry.split(EXPIRY_SEPARATOR);
      let month = expiryParts[0] || '';
      let year = expiryParts[1] || '';

      // if month too short take from year if it has value
      if (year && (!month || parseInt(month) === 0)) {
        month = '0' + year.substring(0, 1);
        year = year.substring(1);
      }

      if (month) {
        let oldMonth = month;
        const MAX_MONTH = 12;

        // pad month with zeroes
        if ((year && month.length < 2) || parseInt(month.substring(0, 1)) > 1 || parseInt(month.substring(0, 2)) > MAX_MONTH) {
          month = '0' + month;
        } else if (parseInt(month) === 0) {
          month = '0';
        }

        // if month was not formatted prepend extra digits to year
        if (oldMonth === month || (!year)) {
          year = month.substring(2) + year;
        }
        // restrict month to two digits
        month = month.substring(0,2);
      }

      // restrict year to two digits
      year = year.slice(-2);

      formatted = month;

      // join with separator
      if (year || ((month.length == 2) && (appendSeparator)) ) {
        formatted = month + ' ' + EXPIRY_SEPARATOR + ' ' + year;
      }
    }

    return formatted;
  },

  cvv: function(cvv, cardBrand) {
    if (cvv === null) {
      return '';
    }

    let length = 4;
    length = cardBrand.cvvLength ? cardBrand.cvvLength : length;

    cvv = cvv.replace(/\D/g, '');
    return cvv.substring(0, length);
  },
};

module.exports = Format;


// WEBPACK FOOTER //
// ./app/format.js